import * as fromSessionSelectors from './session.selectors';
import * as fromTitlebarSelectors from './titlebar.selectors';


export const sessionSelectors = fromSessionSelectors;

export const titlebarSelectors = fromTitlebarSelectors;




export const appSelectors = {
    sessionSelectors,
    titlebarSelectors,
    
    
    
}